import React, { useState, useEffect } from 'react';
import { getContents, createContent, updateContent, deleteContent, toggleContentStatus } from '../../services/api';
import DataTable from '../components/DataTable';
import ContentForm from '../forms/ContentForm';
import LoadingSpinner from '../components/LoadingSpinner';
import toast from 'react-hot-toast';

const ContentsModule = () => {
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  useEffect(() => {
    fetchContents();
  }, []);

  const fetchContents = async () => {
    setLoading(true);
    try {
      const response = await getContents();
      console.log('Contents response:', response);
      
      // Handle different response formats
      let contentsArray = [];
      if (Array.isArray(response)) {
        contentsArray = response;
      } else if (response.data && Array.isArray(response.data)) {
        contentsArray = response.data;
      } else if (response.success && response.data && Array.isArray(response.data)) {
        contentsArray = response.data;
      }
      
      setContents(contentsArray);
    } catch (error) {
      console.error('Error fetching contents:', error);
      toast.error('Error fetching contents');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this content?')) {
      try {
        await deleteContent(id);
        toast.success('Content deleted successfully');
        fetchContents();
      } catch (error) {
        toast.error('Error deleting content');
      }
    }
  };

  const handleToggle = async (id, currentStatus) => {
    try {
      await toggleContentStatus(id);
      toast.success(`Content ${currentStatus ? 'deactivated' : 'activated'} successfully`);
      fetchContents();
    } catch (error) {
      toast.error('Error toggling status');
    }
  };

  const columns = ['Section ID', 'Title', 'Subtitle', 'Status', 'Actions'];

  const getValue = (item, column) => {
    if (column === 'Section ID') return item.sectionId || '-';
    if (column === 'Title') return item.title || '-';
    if (column === 'Subtitle') return item.subtitle || '-';
    if (column === 'Status') {
      const isActive = item.isActive !== false;
      return (
        <button onClick={() => handleToggle(item._id, isActive)} style={{ 
          padding: '0.25rem 0.75rem', borderRadius: '20px', border: 'none', 
          background: isActive ? '#D4EDDA' : '#F8D7DA', 
          color: isActive ? '#155724' : '#721C24', cursor: 'pointer' 
        }}>
          {isActive ? 'Active' : 'Inactive'}
        </button>
      );
    }
    if (column === 'Actions') {
      return (
        <>
          <button onClick={() => { setEditingItem(item); setShowModal(true); }} style={{ 
            padding: '0.25rem 0.75rem', background: '#2C7A7B', color: 'white', border: 'none', 
            borderRadius: '4px', cursor: 'pointer', marginRight: '0.5rem' 
          }}>Edit</button>
          <button onClick={() => handleDelete(item._id)} style={{ 
            padding: '0.25rem 0.75rem', background: '#DC2626', color: 'white', border: 'none', 
            borderRadius: '4px', cursor: 'pointer' 
          }}>Delete</button>
        </>
      );
    }
    return '-';
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem', flexWrap: 'wrap', gap: '1rem' }}>
        <h2 style={{ color: '#0A192F' }}>Content Manager ({contents.length})</h2>
        <button onClick={() => { setEditingItem(null); setShowModal(true); }} style={{ 
          padding: '0.5rem 1rem', background: '#2C7A7B', color: 'white', border: 'none', 
          borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem' 
        }}>
          <i className="fas fa-plus" /> Add New Content
        </button>
      </div>

      {contents.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', background: '#F7F9FC', borderRadius: '12px' }}>
          <i className="fas fa-database" style={{ fontSize: '3rem', color: '#CBD5E1', marginBottom: '1rem' }} />
          <p style={{ color: '#5A6E7F' }}>No content found in database. Click "Add New Content" to create.</p>
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <thead style={{ background: '#F7F9FC' }}>
              <tr>
                {columns.map((col, idx) => <th key={idx} style={{ padding: '1rem', textAlign: 'left' }}>{col}</th>)}
              </tr>
            </thead>
            <tbody>
              {contents.map((item) => (
                <tr key={item._id} style={{ borderBottom: '1px solid #E2E8F0' }}>
                  {columns.map((col, idx) => <td key={idx} style={{ padding: '1rem' }}>{getValue(item, col)}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showModal && (
        <ContentForm 
          editingItem={editingItem} 
          onClose={() => { setShowModal(false); setEditingItem(null); }} 
          onRefresh={fetchContents} 
        />
      )}
    </div>
  );
};

export default ContentsModule;